import React, { useState } from 'react';
import { Grid, Card } from '@mui/material';
import { EvalData } from '../page-data/eval-data';
import { EvalAnswers } from '../common/page-data';
import { NegativeTagList } from './negative-tag-list';
import { PositiveTagList } from './positive-tag-list';

interface ComponentProps {
  pageData: EvalData;
  instructions: string;
  onChange?: VoidFunction;
  disabled?: boolean;
}

type Props = ComponentProps;
//------------------------------------------------------------------------------
const EvalTagsComp: React.FC<Props> = (props) => {
  const {
    instructions,
    pageData,
    pageData: { tags: options, tagsToAvoid },
    disabled
  } = props;

  const [evalAnswers, setEvalAnswers] = useState<EvalAnswers>(
    pageData.evalAnswers
  );

  const onChange = (evalAnswers: EvalAnswers) => {
    pageData.evalAnswers = evalAnswers;
    setEvalAnswers(evalAnswers);
    props.onChange?.();
  };

  return (
    <Card sx={{ margin: '0.5em 0' }}>
      <Grid container direction='column'>
        <Grid
          item
          bgcolor='var(--Description-Background)'
          color='var(--Description-Foreground)'
          sx={{ p: 2 }}
        >
          {instructions}
        </Grid>
        <Grid item sx={{ color: 'success.main', py: 2, px: 1 }}>
          Should include
          <PositiveTagList
            tags={options}
            evalAnswers={evalAnswers}
            onChange={onChange}
            positive
            disabled={disabled}
          />
        </Grid>
        <Grid item sx={{ color: 'error.main', py: 2, px: 1 }}>
          Should avoid
          <NegativeTagList
            tags={tagsToAvoid}
            evalAnswers={evalAnswers}
            onChange={onChange}
            disabled={disabled}
          />
        </Grid>
      </Grid>
    </Card>
  );
};

//******************************************************************************
export const EvalTags = EvalTagsComp;
